import { injectable } from 'inversify'

@injectable()
export class TableScrollbarService {
  public getTableScrollbarId<T extends string>(id: T): `TABLE_${T}` {
    return `TABLE_${id}`
  }
}
